export default { 
  PublicBeranda: require('./PublicBeranda').default,
  PublicStudi: require('./PublicStudi').default,
  PublicDetail: require('./PublicDetail').default,
  PublicPrakerja: require('./PublicPrakerja').default,

}